import axios from 'axios';
import Vue from "vue";
import QS from 'qs';
import { axiosJsonp } from './jsonp';
import {getAPPID} from "./util";
// 接口公共参数
const baseParams = {
  // version: '1.0.0',
  _appid : getAPPID()
};

class http {
  constructor () {
    // 默认设置
    axios.defaults.timeout = 5000;
    axios.defaults.baseURL = '';
    // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    // axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    // 全局设置 axios 发送请求带上cookie
    axios.defaults.withCredentials = true;
    Vue.prototype.$axios = axios;
    axios.defaults.transformRequest = data =>
      // allowDots配置：risksList[0][riskType] => risksList[0].riskType  连接符用 “.”
      QS.stringify(data, {
        allowDots: true,
      });
    // 解决 ios 下部分版本的 uc 浏览器请求接口走 catch 问题
    const ua = navigator.userAgent.toLocaleLowerCase();
    if ((ua.indexOf('iphone') > -1 && ua.indexOf('ucbrowser') > -1) === false) {
      axios.defaults.timeout = 15000;
    }
  }



  // 封装get方法
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get(url, params) {
    params = Object.assign({}, baseParams, params);
    //console.log(url, params);
    return new Promise((resolve, reject) => {
      if(!params._appid){
        params._appid = '2sc.h5'
      }
      axios
        .get(url, {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  };

  // 封装put方法
  /**
   * put方法，对应put请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  put(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }


  getJsonp(url, params) {
    params = Object.assign({}, baseParams, params);
    // console.log(`url: ${url}, -- params: ${JSON.stringify(params)}`);
    return new Promise((resolve, reject) => {
      axiosJsonp({
        method: 'JSONP',
        url: `${url}?${QS.stringify(params)}`,
      })
        .then((response) => {
          resolve(response.data, url);
        })
        .catch((error) => {
          console.log('error' , error);
          reject(error);
        });
    });
  }

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post(url, params) {
    params = Object.assign({}, baseParams, params);
    // console.log(QS.stringify(params));
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

}

export default new http();
//export  { get, post, put, getJsonp };



// WEBPACK FOOTER //
// ./src/util/http.js